import { render, staticRenderFns } from "./PromotionVideo.vue?vue&type=template&id=397b49c2&scoped=true&"
import script from "./PromotionVideo.vue?vue&type=script&lang=js&"
export * from "./PromotionVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397b49c2",
  null
  
)

export default component.exports